import { $api } from "@/shared/api";

import { INGEST_POLL_INTERVAL_MS, isIngestChecking } from "./ingestPolling";

// Присылает ли программа Deadlock API Ingest матчи игрока («Матчи сразу»). Бэкенд отвечает
// из базы и, если статус устарел, ставит проверку — пока она идёт, перезапрашиваем.
export const useIngestStatus = () =>
  $api.useQuery(
    "get",
    "/api/matches/ingest-status",
    {},
    {
      refetchInterval: ({ state }) =>
        isIngestChecking(state.data, state.dataUpdateCount) ? INGEST_POLL_INTERVAL_MS : false,
    },
  );
